/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { OutputImageDynamicPartStatus } from "./OutputImageDynamicPartStatus";

export interface OutputImageDynamicPart {
  type: "output_image_dynamic";
  image_id: string;
  status: OutputImageDynamicPartStatus;
  url?: string | null;
}
